import {
  Dialog,
  DialogContent,
  TableCell,
  TableRow,
  withStyles
} from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import ContractFormComponent from '../lightEntrepreneurs/contractForm.component'
import { updateFormValues } from '../../../form'
// import ContractFormCompContainer from '../../../containers/employer/contract/contractForm.container'
import { useDispatch } from 'react-redux'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    boxSizing: 'border-box'
  }
})

const ContractRow = ({
  classes,
  contract_num,
  start_date,
  end_date,
  status,
  contractData
}) => {
  const dispatch = useDispatch()
  const [isEdit, setIsEdit] = React.useState(false)
  function handleEdit() {
    setIsEdit(true)
  }
  // console.log('huong contract data', contractData)
  return (
    <Translation>
      {() => {
        return (
          <>
            <TableRow>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell)}
              >
                {contract_num}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell)}
              >
                {start_date}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell)}
              >
                {end_date}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classNames(classes.tablecell)}
              >
                {status}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                <div style={{ display: 'flex' }}>
                  <p
                    style={{ marginLeft: '10px', marginRight: '15px' }}
                    className="link action-icon"
                    onClick={() => {
                      handleEdit()
                      dispatch(updateFormValues('contractForm', contractData))
                    }}
                  >
                    <FontAwesome name="pencil" />
                  </p>
                  <p
                    style={{ marginLeft: '10px', marginRight: '15px' }}
                    className="link action-icon"
                    onClick={() => {}}
                  >
                    <FontAwesome
                      name="window-close"
                      style={{ color: '#F67131' }}
                    />
                  </p>
                </div>
              </TableCell>
            </TableRow>
            <Dialog
              open={isEdit}
              onClose={() => {
                setIsEdit(false)
              }}
              fullWidth
              maxWidth="lg"
              BackdropProps={{
                classes: {
                  root: classes.root
                },
                style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {/* <ContractFormCompContainer contractData={contractData} /> */}
              <DialogContent>
                <div>
                  {' '}
                  <ContractFormComponent formLocation="contractTab" />
                </div>
              </DialogContent>
            </Dialog>
          </>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(ContractRow)
